import FeedScenes from '@/scenes/Dybr/Feeds/FeedScenes';
import { MainLoggedOut } from '@/scenes/Dybr/Main/MainLoggedOut';
import NotFound from '@/scenes/Dybr/Static/NotFound';
import { ProfileContainer } from '@/scenes/Dybr/Users/ProfilePage/Profile';
import Footer from '@/scenes/Footer/Footer';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { selectIsSignupIncomplete } from '@/store/user/selectors/selectIsSignupIncomplete';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import SearchScene from './Feeds/SearchScene';
import { MainLoggedIn } from './Main/MainLoggedIn';
import About from './Static/About';
import Contacts from './Static/Contacts';
import Help from './Static/Help/Help';
import Terms from './Static/Terms';
import ForbiddenActions from './Static/TermsDetails/ForbiddenActions';

export function DybrContainer() {
  const [token] = useTokenState();
  const isLoggedIn = Boolean(token);
  const isSignupIncomplete = useSelector(selectIsSignupIncomplete);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const creatingFirstProfile = isLoggedIn && isSignupIncomplete;

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            isLoggedIn && !isSignupIncomplete ? (
              <MainLoggedIn />
            ) : (
              <MainLoggedOut />
            )
          }
        />
        {!creatingFirstProfile && (
          <Route path="feed/*" element={<FeedScenes />} />
        )}
        {!creatingFirstProfile && (
          <Route path="search/*" element={<SearchScene />} />
        )}
        {!creatingFirstProfile && (
          <Route path="profile/:pid" element={<ProfileContainer />} />
        )}

        <Route path="about" element={<About />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="terms" element={<Terms />} />
        <Route path="terms/forbidden-actions" element={<ForbiddenActions />} />
        <Route path="help" element={<Help />} />
        <Route
          path="*"
          element={<NotFound reason={'Dybr scene: не можем найти страницу'} />}
        />
      </Routes>
      <Footer withLemur />
    </>
  );
}
